//@ts-ignore
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const ReferenceTypeForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid grid-cols-2  gap-x-4 mx-4`}>
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
      <TextField
        label={"Note"}
        register={register("note")}
        errors={errors?.note}
      />
    </div>
  );
};

export default ReferenceTypeForm;
